import styled from 'styled-components';
import color from '../../../config/colors.json';

export const StyledRadio = styled.div`

    .container-radio {
        display: flex;
        justify-content: ${({ justifyContent }) => (justifyContent || 'center')};
        flex-direction: row;
        cursor: pointer;
        font-size: 15px;
        text-align: center;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        font-family: 'Poppins', Arial, Helvetica, sans-serif;
    }

    /* Hide the browser's default radio button */
    .container-radio input {
        display: none;
        opacity: 0;
        cursor: pointer;
    }

    /* Create a custom radio button */
    .checkmark {
        display: block;
        top: 0;
        left: 0;
        height: 14.35px;
        width: 14.35px;
        background-color: ${color.light};
        border: 1px solid ${color.darkGrey};
        border-radius: 50%;
        margin-right: 7px;
    }

    /* On mouse-over, add a grey background color */
    .container-radio:hover input ~ .checkmark {
        background-color: #ccc;
    }

    /* When the radio button is checked, add a blue background */
    input:checked ~ .checkmark {
        background-color: ${color.light};
        border: 1px solid ${color.darkGrey};
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmark:after {
        content: "";
        display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the indicator (dot/circle) */
    .checkmark:after {
        margin-top: 1px;
        margin-left: 1px;
        width: 10.35px;
        height: 10.35px;
        border-radius: 50%;
        background: ${color.darkGrey};
    }

    .label{
        margin-top: -4px;
    }
`;
